import React from 'react';
import { useState, useEffect } from 'react';
import ApiService from '../../services/ApiService';
import { Link, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import CustomButtons from '../../components/Elements/Buttons/customButton';
import CustomInput from '../../components/Elements/input/customInput';
import CustomLink from '../../components/Elements/Link/link';
import CustomTittle from '../../components/Elements/customTittle/customTittle';

import BuyNavigationBar from './navigation/navigationBuy';
import "./chooseUserBuy.css"
import ChooseUser from './chooseUser/chooseUser';
import Modal from '../../components/Elements/modal/modal';
import NewPerson from './addNewConectedPerson/newPerson';
import StepsOfBuy from '../summary/navigatorBarSummary/stepsOfBuy/stepsOfBuy';
import NavigatorBar from './navigation/navigationBar/navigationBar';
import { API_URL } from '../../config';
import { setUsersPayer } from '../../reducers/reposReducers';
import EDSFooter from '../../components/EDSFooter';

import axios from 'axios';
const ChooseUserBuy = (props) => {
   const getSubaccountsURL = `${API_URL}GetSubaccounts`;
  const config = { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } };
  const [res, setResponse] = useState([]);
  const [getResponse, setGetResponse] = useState(0);
  const [allert, setallert] = useState(false);
  const [selectUsersId, setSelectUsersId] = useState();
  const [isRelatedPerson, setIsReletedPerson] = useState(false);
  const apiService = ApiService.getInstance();
 
  const usersPayerDispatch = useDispatch();
    const usersParticipantDispatch = useDispatch();
  const history = useHistory();
   const stepsIndex = 1;
   const [wrapNavigator, setWrapNavigator] = useState(false);
  let [modalClass, showModal] = useState("modal hidden")
  function changeModal(){
 if(modalClass == "modal hidden"){
    showModal("modal")
 }else{
    showModal("modal hidden")
 }
  }
  function showModalLogout(){
    let modalLogout = document.getElementById("modalLogout")
    modalLogout.classList.remove("hidden")
  }
  function tegetRelationsUsersst() {
   setallert(true);
   
   axios
       .get(getSubaccountsURL, config)
       .then((response) => {
   
         setResponse(response.data);
           setGetResponse(response.data.length);
           setTimeout(() => {
               setallert(false);
           }, 800);

       })
       .catch(function (error) {
           if (error.response.status == 401) {
               history.push('/Error_sesja_wygasla');
               setallert(false);
           }
       });
   
       
}
function closeLogoutModal(e){
  e.preventDefault()
    let modalLogout = document.getElementById("modalLogout")
    modalLogout.classList.add("hidden")
}
function logout() {
  localStorage.clear();

  // window.location.hash = '#/Error_sesja_wygasla';
  history.push('/');
  // window.location.href = "http://egurrola.com/"
}
useEffect(()=>{
  let u = Date.now().toString(16) + Math.random().toString(16) + '0'.repeat(16);
  let mongoguid =  [u.substr(0,8), u.substr(8,4), '4000-8' + u.substr(13,3), u.substr(16,12)].join('-');
  localStorage.setItem("guid",mongoguid)
  props.setTracking(mongoguid)
},[])

    return <>
     
    <div className={modalClass}>
    <Modal close={changeModal}>
    <NewPerson onRefresh={tegetRelationsUsersst} close={changeModal}></NewPerson>
    </Modal>
    </div>




      <div className='chooseUSer'>
      <ChooseUser next={props.next} wrapNavigator={props.wrapNavigator} setWrapNavigator={props.setWrapNavigator}  header={props.header} setHeader={props.setHeader} showModal={changeModal} setOption={(e)=>{setResponse(e)}} option={res}></ChooseUser>
      </div>
      
    </>
    }

export default ChooseUserBuy;
